export default __webpack_public_path__ + "static/media/label_optimisim.8f04c1ff.png";